// extracted by mini-css-extract-plugin
module.exports = {"header":"infoStop_header__1s12T","div":"infoStop_div__13AEl","link":"infoStop_link__3wyTN","lines":"infoStop_lines__2haVk","time":"infoStop_time__1yQNX"};